import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-044fb2a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home-banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "社会招聘", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "申请", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import life from '@/components/life/index.vue'
import story from '@/components/story/story.vue'
import singleStory from '@/components/story/singleStory.vue'
import singleLife from '@/components/life/singleLife.vue'
import h5Title from '@/components/title/h5title.vue'
import h5Banner from '@/components/banner/banner-h5.vue'
import ZSwitch from '@/components/layout/z-switch.vue'
import { useRouter, useRoute } from 'vue-router'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const type = ref(null)
if (route.query && route.query.type) {
  type.value = route.query.type
  console.log('运行了', route.meta.title)
}
const handleRouteTo = () => {
  router.push({ name: 'social' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!type.value)
      ? (_openBlock(), _createBlock(ZSwitch, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (!type.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(h5Banner, { activeType: "2" })
            ]),
            _createElementVNode("div", {
              class: "home-card",
              onClick: handleRouteTo
            }, _hoisted_5)
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "life-and-story",
        style: _normalizeStyle({ 'margin-top': type.value ? '0' : '0.75rem' })
      }, [
        (type.value === 'life')
          ? (_openBlock(), _createBlock(singleLife, { key: 0 }))
          : _createCommentVNode("", true),
        (!type.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(h5Title, { titleName: "中通生活" }),
              _createVNode(life, { recruitingType: 1 })
            ], 64))
          : _createCommentVNode("", true),
        (type.value === 'story')
          ? (_openBlock(), _createBlock(singleStory, { key: 2 }))
          : _createCommentVNode("", true),
        (!type.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(h5Title, {
                titleName: "员工故事",
                style: {"margin-top":"0.67rem"}
              }),
              _createVNode(story, { recruitingType: 1 })
            ], 64))
          : _createCommentVNode("", true)
      ], 4)
    ])
  ], 64))
}
}

})